// import Auth from '@/Views/Main/User/Auth';
// import Register from '@/Views/Main/User/Register';
// import Profile from "@/Views/Main/User/Profile";
// import SettingsMain from "@/Views/Main/User/ProfileSettings/Main";
// import SettingsAvatar from "@/Views/Main/User/ProfileSettings/Avatar";
// import Visual from "../Views/Main/User/ProfileSettings/Visual";

import Home from "../Views/Views/Main/Home";
import NotFoundPage from "../Views/Views/Main/NotFoundPage";

export default [
  // Main
  {
    path: '/home',
    name: 'HomePage',
    meta: {layout: 'Main'},
    component: Home,
  },
  {
    path: '/',
    redirect: { name: 'HomePage' }
  },
  {
    path: '*',
    name: 'NotFoundPage',
    meta: {layout: 'Main'},
    component: NotFoundPage,
  },
  // Auth
  {
    path: '/auth',
    name: 'Auth',
    meta: {layout: 'Main'},
    // component: Auth,
  },

  // Register
  {
    path: '/register',
    name: 'Register',
    meta: {layout: 'Main'},
    // component: Register,
  },

  // Profile

  {
    path: '/user/:user_id',
    props: true,
    name: 'Profile',
    meta: {layout: 'Main'},
    // component: Profile
  },

  {
    path: '/user/:user_id/settings',
    redirect: {name: 'ProfileSettings'}
  },

  {
    path: '/user/:user_id/settings/main',
    props: true,
    name: 'ProfileSettings',
    meta: {layout: 'Main', child_layout: 'Profile'},
    // component: SettingsMain
  },

  {
    path: '/user/:user_id/settings/visual',
    props: true,
    name: 'ProfileVisual',
    meta: {layout: 'Main', child_layout: 'Profile'},
    // component: Visual
  },

  {
    path: '/user/:user_id/settings/avatar',
    props: true,
    name: 'ProfileSettingsAvatar',
    meta: {layout: 'Main', child_layout: 'Profile'},
    // component: SettingsAvatar
  },

];
